import { EcoFeeModalEnum } from '@inter-ikea-kompis/component-eco-fee';

enum MiniPriceModalEnum {
	ecoFeeCard = EcoFeeModalEnum.ecoFeeCard
}

export default MiniPriceModalEnum;
